import { REDUCE_POLICY } from '../../constants/actions/policy';

export function reducePolicy(payload) {
    return {
        type: REDUCE_POLICY,
        payload,
    };
}
